<template>
  <div class="primary-main bank-main school-manage" v-loading="loading">
    <div class="jsgl-search">
      <el-select v-model="zt" placeholder="请选择状态" style="width: 150px; margin-right: 10px; margin-bottom: 10px;" @change="searchYw">
        <el-option label="启用" :value="1"></el-option>
        <el-option label="禁用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="addYw" style="margin: 0 10px 10px 0;" icon="el-icon-plus">新增</el-button>
    </div>
    <div class="jsgl-table">
      <el-table :data="tableData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column type="index" align="center" width="80" label="序号"></el-table-column>
        <el-table-column prop="ywmc" label="业务名称"></el-table-column>
        <el-table-column prop="ywcode" label="业务Code"></el-table-column>
        <el-table-column label="图标" align="center">
          <template slot-scope="scope">
             <img v-if="scope.row.ywtbUrl" :src="getFullUrl(scope.row.ywtbUrl)" style="width: 40px; height: 40px; object-fit: contain;" />
          </template>
        </el-table-column>
        <el-table-column prop="px" label="排序号" width="100"></el-table-column>
        <el-table-column align="center" width="100" label="状态">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.zt==0" type="danger">禁用</el-tag>
            <el-tag size="mini" v-if="scope.row.zt==1">启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-button type="text" @click="updateStatus(scope.row.id, 1)" v-if="scope.row.zt == 0">启用</el-button>
            <el-button type="text" @click="updateStatus(scope.row.id, 0)" v-if="scope.row.zt == 1">禁用</el-button>
            <el-button type="text" @click="editYw(scope.row.id)" v-if="scope.row.zt == 0">修改</el-button>
            <el-button type="text" @click="delYw(scope.row.id)" style="color: #F56C6C;" v-if="scope.row.zt == 0">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
          :title="dialogTitle?'修改业务':'新增业务'"
          :visible.sync="dialogVisible"
          width="500px"
          @close="handleClose"
          :close-on-click-modal="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="业务名称" prop="ywmc">
            <el-input v-model="ruleForm.ywmc" maxlength="50" clearable placeholder="请输入业务名称"></el-input>
          </el-form-item>
          <el-form-item label="业务Code" prop="ywcode">
            <el-input v-model="ruleForm.ywcode" maxlength="50" clearable placeholder="请输入业务Code" :disabled="dialogTitle"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="ywtbUrl">
            <el-upload
              class="avatar-uploader"
              action="api/common/uploadFile" 
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :data="uploadData">
              <img v-if="ruleForm.ywtbUrl" :src="getFullUrl(ruleForm.ywtbUrl)" class="avatar" style="width: 100px; height: 100px; object-fit: contain; border: 1px dashed #d9d9d9; border-radius: 6px;">
              <i v-else class="el-icon-plus avatar-uploader-icon" style="font-size: 28px; color: #8c939d; width: 100px; height: 100px; line-height: 100px; text-align: center; border: 1px dashed #d9d9d9; border-radius: 6px;"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="排序号" prop="px">
             <el-input-number v-model="ruleForm.px" :min="0" label="排序号"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveYw('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "ywList",
  data() {
    return {
      loading: false,
      zt: null, // Default to Enabled
      tableData: [],
      dialogVisible: false,
      dialogTitle: false, // false for add, true for edit
      ruleForm: {
        id: '',
        ywmc: '',
        ywcode: '',
        ywtbUrl: '',
        px: 0,
        zt: 1
      },
      rules: {
        ywmc: [{ required: true, message: '请输入业务名称', trigger: 'blur' }],
        ywcode: [{ required: true, message: '请输入业务Code', trigger: 'blur' }],
        px: [{ required: true, message: '请输入排序号', trigger: 'blur' }]
      },
      uploadData: {
          'access_token': sessionStorage.getItem("access_token"),
          'moduleName': 'ywtb'
      },
      access_token: sessionStorage.getItem("access_token")
    };
  },
  mounted() {
    this.getYwList();
  },
  methods: {
    getFullUrl(url) {
      if (!url) return '';
      if (url.indexOf('http') === 0) return url;
      if (url.indexOf('/') === 0) {
        url = url.substring(1);
      }
      // Append access_token if needed, assuming url is like /api/sys/download...
      if (url.indexOf('?') > -1) {
          return url + '&access_token=' + this.access_token;
      } else {
          return url + '?access_token=' + this.access_token;
      }
    },
    searchYw() {
      this.getYwList();
    },
    getYwList() {
      let _this = this;
      _this.loading = true;
      let params = {
          zt: _this.zt
      };
      _this.$post('admin/YwController/list', params).then((rep) => {
        _this.loading = false;
        if (rep.code == 1) {
          _this.tableData = rep.result.list;
        } else {
          _this.$message({ type: "error", message: rep.msg });
        }
      });
    },
    addYw() {
      this.dialogVisible = true;
      this.dialogTitle = false;
      this.ruleForm = {
        id: '',
        ywmc: '',
        ywcode: '',
        ywtbUrl: '',
        px: 0,
        zt: 1 // Default enabled
      };
      if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].resetFields();
      }
    },
    editYw(id) {
      let _this = this;
      _this.loading = true;
      _this.$post('admin/YwController/view', { id: id }).then((rep) => {
        _this.loading = false;
        if (rep.code == 1) {
          let yw = rep.result.yw;
          _this.ruleForm = {
            id: yw.id,
            ywmc: yw.ywmc,
            ywcode: yw.ywcode,
            ywtbUrl: yw.ywtbUrl,
            px: yw.px,
            zt: yw.zt
          };
          _this.dialogVisible = true;
          _this.dialogTitle = true;
        } else {
          _this.$message({ type: "error", message: rep.msg });
        }
      });
    },
    saveYw(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.loading = true;
          _this.$post('admin/YwController/save', _this.ruleForm).then((rep) => {
            _this.loading = false;
            if (rep.code == 1) {
              _this.$message({ type: "success", message: _this.dialogTitle ? '修改成功' : '新增成功' });
              _this.dialogVisible = false;
              _this.getYwList();
            } else {
              _this.$message({ type: "error", message: rep.msg });
            }
          });
        }
      });
    },
    delYw(id) {
      let _this = this;
      _this.$confirm('确认删除该业务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        _this.$post('admin/YwController/delete', { id: id }).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.$message({ type: "success", message: '删除成功' });
            _this.getYwList();
          } else {
            _this.$message({ type: "error", message: rep.msg });
          }
        });
      }).catch(() => {});
    },
    updateStatus(id, zt) {
      let _this = this;
      let action = zt == 1 ? '启用' : '禁用';
      _this.$confirm('确认' + action + '该业务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        _this.$post('admin/YwController/updateStatus', { id: id, zt: zt }).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.$message({ type: "success", message: action + '成功' });
            _this.getYwList();
          } else {
            _this.$message({ type: "error", message: rep.msg });
          }
        });
      }).catch(() => {});
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs['ruleForm'].resetFields();
    },
    handleAvatarSuccess(res, file) {
      if (res.resultCode == 0) {
          this.ruleForm.ywtbUrl = res.data.ylUrl;
          this.$forceUpdate();
      } else {
          this.$message.error('上传失败: ' + res.msg);
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    }
  }
}
</script>

<style lang="less" scoped>
  .jsgl-search{
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
  }
  .jsgl-table{
      .el-table{
      }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
